<template>
  <div class="row-fluid justify-content-center text-center">
    <h5>
      {{ accountInfo.cancellationtext }}.
    </h5>
    <p class="row-fluid justify-content-center text-center">
      {{ extText }}
    </p>
    <hr v-if="accountInfo.cancellationtext">
    <div class="vtd-form-group">
      <b-form-checkbox
        id="checkbox-1"
        v-model="terms"
        size="sm"
        name="checkbox-1"
        :style=" validateError ? 'color:red; font-weight: bold;': 'color:black;'"
      >
        I understand and accept these cancellation conditions.
      </b-form-checkbox>
    </div>
    <button
      class="btn btn-success m-auto rounded" 
      @click="proceed"
    >
      Proceed To Next Step
    </button>
    <LoginToken
      ref="LoginTokenRef"
      :cancellation="true"
      @passSetPassenger="(pas) => $emit('setPassenger', pas)"
    />
  </div>
</template>
<script>
import LoginToken from "@/modules/auth/login-token";

export default {
    components: {
    LoginToken
    },
    props: [
        'accountInfo',
        'method',
        'currency',
        'canxVal',
        'extText'
         ],
         data() {
            return {
                terms: false,
                validateError: false
            }
         },
         methods: {
            proceed() {
                this.validateError = false
                if (!this.terms) {
                    this.validateError = true
                    setTimeout(() => {
                        this.validateError = false
                    }, 8000);
                    return ;
                }
                this.$refs.LoginTokenRef.authCheckResult(() => {
                    this.$emit('setTerms', this.terms)
                    this.$emit('nextStage', 2)
                })
            },
         }
}
</script>
